/**
 * Backend origin for API calls.
 * - Set REACT_APP_BACKEND_URL when the API is on another host (required for many prod setups).
 * - Local dev: defaults to http://127.0.0.1:8000 if unset (matches typical uvicorn).
 * - Production build without env: uses window.location.origin (same host as the SPA).
 */
function getBackendUrl() {
  const env = process.env.REACT_APP_BACKEND_URL;
  if (env) return env.replace(/\/$/, '');
  if (process.env.NODE_ENV === 'development') return 'http://127.0.0.1:8000';
  if (typeof window !== 'undefined' && window.location?.origin) return window.location.origin;
  return '';
}

export const BACKEND_URL = getBackendUrl();
export const API_URL = `${BACKEND_URL}/api`;
